var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-contained"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11.0487 3.35156H5.04873C3.06051 3.35156 1.44873 4.96333 1.44873 6.95156V18.9517C1.44873 20.9399 3.06051 22.5517 5.04873 22.5517H17.0487C19.037 22.5517 20.6487 20.9399 20.6487 18.9517L20.6487 12.9516M7.44873 16.5516L11.8147 15.6718C12.0465 15.6251 12.2593 15.511 12.4264 15.3438L22.2001 5.56474C22.6687 5.09588 22.6684 4.33589 22.1994 3.86743L20.129 1.79936C19.6602 1.33109 18.9006 1.33141 18.4322 1.80007L8.65749 11.5801C8.49068 11.747 8.37678 11.9594 8.33003 12.1907L7.44873 16.5516Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/Show.1d36482fab39e4234a266b4cf0747951.svg";
export { ForwardRef as ReactComponent };